document.querySelectorAll('.mega-menu').forEach(function (megaMenu) {
  const childLinks = megaMenu.querySelectorAll('.mega-menu__link--level-2');
  const grandchildPanels = megaMenu.querySelectorAll('.mega-menu__grandchildren[data-child-handle]');
  const leftLinks = megaMenu.querySelectorAll('#mega-menu__navlist__left a[id^="HeaderMenu__"]');

  function setActiveLink(link) {
    leftLinks.forEach(l => l.classList.remove('link-active'));
    link.classList.add('link-active');
  }

  function showGrandchildrenPanel(handle) {
    grandchildPanels.forEach(function (panel) {
      panel.style.display = (panel.dataset.childHandle === handle) ? 'flex' : 'none';
    });
  }

  // Show grandchild panel and set active link on hover
  childLinks.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      const handle = this.id.replace('HeaderMenu__', '');
      showGrandchildrenPanel(handle);
      setActiveLink(link);
    });
  });

  // Set active and show first grandchild panel only when parent menu is opened
  document.querySelectorAll('.header__menu-item').forEach(function (parentLink) {
    parentLink.addEventListener('click', function () {
      // Find the related megaMenu
      const targetMenuId = this.getAttribute('aria-controls');
      const targetMenu = document.getElementById(targetMenuId);

      if (targetMenu) {
        const firstChildLink = targetMenu.querySelector('.mega-menu__link--level-2');
        if (firstChildLink) {
          const firstHandle = firstChildLink.id.replace('HeaderMenu__', '');
          showGrandchildrenPanel(firstHandle);
          setActiveLink(firstChildLink);
        }
      }
    });
  });
});

